//
// VariantRadios
//
class VariantRadios extends HTMLElement {
  constructor() {
    super();

    this.productId = this.dataset.productId;

    this.colorContainer = this.closest("[data-active-color]");
    this.media = document.querySelector(".product__media");
    this.variantSelect = document.querySelector('[name="id"]');
    this.buyButtons = () => {
      return document.querySelectorAll('[name="add"]');
    };
    this.buyButton = this.buyButtons()[0];

    // this.setVariantSelectOption();

    this.addEventListener("change", this.onChange.bind(this));
  }

  onChange(ev) {
    this.activateLabelsForSelectedOption(ev.target);
    this.setVariant(ev.target);
  }

  variantsForTitleGeneration() {
    return Array.from(
      this.querySelectorAll(
        'input[type="radio"]:not([name*=properties]):checked'
      )
    );
  }

  variantTitleFromRadios(el) {
    let title = this.variantsForTitleGeneration()
      .sort((a, b) => {
        return a.dataset.optionPosition - b.dataset.optionPosition;
      })
      .map((radio) => {
        return radio.value.replace(/\+/, " ");
      })
      .join(" / ");

    return decodeURI(title);
  }

  activateLabelsForSelectedOption(option) {
    let label = document.getElementById(`label-${option.id}`);
    if (label) {
      Array.from(label.parentNode.children).forEach((sibling) => {
        sibling.classList.remove("active");
      });
      label.classList.add("active");
    }
  }

  getVariantSelectOptionForRadios(el) {
    return Array.from(this.variantSelect.options).find(
      (option) => option.text === this.variantTitleFromRadios()
    );
  }

  setVariantSelectOption(el) {
    let foundOption = this.getVariantSelectOptionForRadios(el);

    if (foundOption) {
      this.selectedVariantOption = foundOption;
      this.selectedVariantOption.selected = true;
    }
  }

  setVariant(el) {
    this.setVariantSelectOption(el);
    if (!this.selectedVariantOption) return;

    this.setPrices();
    this.setAvailability();
    this.setColor();
    this.setVariantUrl();
    // this.scrollToFirstImage();
  }

  scrollToFirstImage() {
    this.media.scrollIntoView({ behavior: "smooth" });
  }

  getPriceTemplate() {
    let priceTemplate = this.querySelector(
      `[id="price-${this.selectedVariantOption.value}"]`
    )?.innerHTML;

    let priceElement = new DOMParser()
      .parseFromString(priceTemplate, "text/html")
      .querySelector(".price");

    return priceElement;
  }

  setVariantUrl() {
    let title = this.selectedVariantOption.dataset.title;
    let url = this.selectedVariantOption.dataset.url;

    if (url) {
      window.history.pushState({}, title, url);
    }
  }

  setPrices() {
    const priceTemplate = this.getPriceTemplate();

    if (!priceTemplate) return;

    Array.from(
      document.querySelectorAll(`[data-price="${this.productId}"]`)
    ).forEach((priceElement) => {
      priceElement.replaceWith(priceTemplate.cloneNode(true));
    });
  }

  setAvailability() {
    this.setButtons(
      this.selectedVariantOption.disabled,
      this.selectedVariantOption.disabled
        ? window.i18n.products.product.sold_out
        : window.i18n.products.product.add_to_cart
    );
  }

  setButtons(disabled, text) {
    this.buyButtons().forEach((buyButton) => {
      buyButton.disabled = disabled;
      buyButton.textElement = buyButton.querySelector("span") || this.buyButton;
      buyButton.textElement.textContent = text;
    });
  }

  setColor() {
    if (!this.selectedVariantOption.dataset.color) return;

    this.colorContainer.dataset.activeColor =
      this.selectedVariantOption.dataset.color;
  }
}

customElements.define("variant-radios", VariantRadios);
